<div [formGroup]="formGroup">
  <div [ngSwitch]="attributeControl.controlType">
    <div *ngIf="attributeControl.controlType === 'text' ||
                attributeControl.controlType === 'text_capital' ||
                attributeControl.controlType === 'integer'" class="input-group">
      <input *ngSwitchCase="'text'" type="text" class="form-control"
             [class.form-control-sm] = "isSmallSize"
             [formControlName]="attributeControl.name"
             [name]="attributeControl.key"
             [maxlength]="attributeControl.maxLength"
             [pattern]="attributeControl.pattern"
             (change) = "onChange($event)"
             [readonly]="isReadonly">
      <input *ngSwitchCase="'text_capital'" type="text" class="form-control"
             [class.form-control-sm] = "isSmallSize"
             [formControlName]="attributeControl.name"
             [name]="attributeControl.key"
             [maxlength]="attributeControl.maxLength"
             (keyup)="onKeyup(attributeControl.name)"
             (change) = "onChange($event)"
             [readonly]="isReadonly" >
      <input *ngSwitchCase="'integer'" type="number" class="form-control"
             [class.form-control-sm] = "isSmallSize"
             [formControlName]="attributeControl.name"
             [name]="attributeControl.key"
             [pattern]="attributeControl.pattern"
             (change) = "onChange($event)"
             [readonly]="isReadonly" >
      <div *ngIf="attributeControl.searchHelpId || attributeControl.domainRelationId" class="input-group-append">
        <button class="btn btn-outline-secondary btn-sm" type="button" (click)="onSearchHelp(attributeControl)">
          <span class="fas fa-search"></span>
        </button>
      </div>
    </div>
    <input *ngSwitchCase="'decimal'" type="number" class="form-control"
           [class.form-control-sm] = "isSmallSize"
           [formControlName]="attributeControl.name"
           [name]="attributeControl.key"
           [step]="attributeControl.step"
           [placeholder]="attributeControl.placeholder"
           [pattern]="attributeControl.pattern"
           (change) = "onChange($event)"
           [readonly]="isReadonly" >
    <input *ngSwitchCase="'checkbox'" type="checkbox" class="mb-1 ml-1"
           [class.form-control-sm] = "isSmallSize"
           [formControlName]="attributeControl.name"
           (change) = "onChange($event)"
           [name]="attributeControl.key">
    <textarea *ngSwitchCase="'textarea'" class="form-control"
              [class.form-control-sm] = "isSmallSize"
              [formControlName]="attributeControl.name"
              [name]="attributeControl.key"
              [rows]="attributeControl.rows"
              (change) = "onChange($event)"
              [readonly]="isReadonly"></textarea>
    <input *ngSwitchCase="'file'" type="file" class="form-control"
           [class.form-control-sm] = "isSmallSize"
           [formControlName]="attributeControl.name"
           [name]="attributeControl.key"
           (change) = "onChange($event)"
           [readonly]="isReadonly" >
    <input *ngSwitchCase="'date'" type="date" class="form-control"
           [class.form-control-sm] = "isSmallSize"
           [formControlName]="attributeControl.name"
           [name]="attributeControl.key"
           (change) = "onChange($event)"
           [readonly]="isReadonly" >
    <input *ngSwitchCase="'timestamp'" type="datetime-local" class="form-control" step="1"
           [class.form-control-sm] = "isSmallSize"
           [(localDatetime)] = "localDatetime"
           (dateChange)="onDateChange($event)"
           [name]="attributeControl.key"
           (change) = "onChange($event)"
           [readonly]="isReadonly" >
    <input *ngSwitchCase="'password'" type="password" class="form-control"
           [class.form-control-sm] = "isSmallSize"
           [formControlName]="attributeControl.name"
           [name]="attributeControl.key"
           (change) = "onChange($event)"
           [readonly]="isReadonly" >
    <select *ngSwitchCase="'dropdown'" class="form-control"
            [class.form-control-sm] = "isSmallSize"
            [formControlName]="attributeControl.name"
            [name]="attributeControl.key"
            (change) = "onChange($event)">
      <option *ngFor="let opt of attributeControl.dropdownList" [value]="opt.key">{{opt.value}}</option>
    </select>
  </div>

  <div *ngIf="!noErrorMsg" [class.ng-invalid]="invalid" class="dk-invalid-feedback">
    {{errorMessage}}
  </div>
</div>

<dk-app-search-help></dk-app-search-help>
